module.exports = __webpack_public_path__ + "static/Tile3-infrared-426fc8e72979446720e656506e743c08.gif";